export const apiEndpoint = 'https://mainnet.infura.io/v3/297ba684ac944114b78eb8e53838822c'
